import { cx } from "class-variance-authority";
import { CourseIcon, IndustryReportIcon, LightCourseIcon, LightIndustryReportIcon } from "./NavigationIcon";
import Link from "@/03-presenters/widgets/LinkWithCountryCode";
import { openTitleStore } from "./Navigation";
const knowledgeList = [{
  title: "出海星球",
  icon: <CourseIcon />,
  lightIcon: <LightCourseIcon />,
  href: "/ecAcademy",
  description: "赋能电商未来，成就每一份创业梦想"
}, {
  title: "行业报告",
  icon: <IndustryReportIcon />,
  lightIcon: <LightIndustryReportIcon />,
  href: "/aiReport",
  description: "出海匠专业数据为您定制，掌握跨境电商市场先机"
}];
export default function CustomKnowledge({
  isHomePage = false
}: {
  isHomePage?: boolean;
}) {
  const hoverBgColor = isHomePage ? "bg-[#2F2C3A]" : "bg-[#F4F5F9]";
  const setOpenTitle = openTitleStore(state => state.setOpenTitle);
  return <div className="ml-20 grid grid-cols-2 gap-8" onClick={() => setOpenTitle(null)} data-sentry-component="CustomKnowledge" data-sentry-source-file="CustomKnowledge.tsx">
      {knowledgeList.map(item => <Link key={item.title} href={item.href}>
          <div className={cx("flex gap-2 rounded-sm p-2 pb-4", hoverBgColor)}>
            {isHomePage ? item.icon : item.lightIcon}
            <div className="mt-0.5 flex w-[160px] flex-col gap-2">
              <span className={cx(isHomePage ? "text-white" : "text-[#000]")}>
                {item.title}
              </span>
              <span className={cx("text-xs", isHomePage ? "text-[#86909C]" : "text-[#8C9296]")}>
                {item.description}
              </span>
            </div>
          </div>
        </Link>)}
    </div>;
}